import qs from "querystring";
import Api from "../lib/request";
import CONSTANT from "../constant/cookie";
import _ from "underscore";
import cookie from "../lib/cookie";
const getProvince = data => {
  return new Promise((resolve, reject) => {
    let query = "";
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`;
    }
    var url = `${CONSTANT.REQUEST_HOST}${query}`;

    Api.get(url, {
      headers: {
        "X-Host": "mall.cfg.province.list",
        "X-Token": cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(
      data => {
        if (data.status !== 0) {
          return reject(data.msg);
        }
        resolve(data.data);
      },
      e => {
        reject(e);
      }
    );
  });
};
const getCity = data => {
  return new Promise((resolve, reject) => {
    let query = "";
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`;
    }
    var url = `${CONSTANT.REQUEST_HOST}${query}`;

    Api.get(url, {
      headers: {
        "X-Host": "mall.cfg.city.list",
        "X-Token": cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(
      data => {
        if (data.status !== 0) {
          return reject(data.msg);
        }
        resolve(data.data);
      },
      e => {
        reject(e);
      }
    );
  });
};
const getDistrict = data => {
  return new Promise((resolve, reject) => {
    let query = "";
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`;
    }
    var url = `${CONSTANT.REQUEST_HOST}${query}`;

    Api.get(url, {
      headers: {
        "X-Host": "mall.cfg.district.list",
        "X-Token": cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(
      data => {
        if (data.status !== 0) {
          return reject(data.msg);
        }
        resolve(data.data);
      },
      e => {
        reject(e);
      }
    );
  });
};
/*yeoman-template-point-1*/
export default {
  getProvince,
  getCity,
  getDistrict
  /*yeoman-template-point-2*/
};
